export default __webpack_public_path__ + "static/media/004-newspaper.29969a98.svg";